import styled, { css } from "styled-components";

export const h1Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 120%;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 40px;
  }
`;

export const h1 = styled.h1`
  ${h1Css}
`;

export const h2Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 106%;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 30px;
  }
`;

export const h2 = styled.h2`
  ${h2Css}
`;

export const h3Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 106%;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 24px;
  }
`;

export const h3 = styled.h3`
  ${h3Css}
`;

export const h4Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 106%;
  @media ${({ theme }) => theme.breakpoints.xs} {
    font-size: 20px;
  }
`;

export const h4 = styled.h4`
  ${h4Css}
`;

export const h5Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
`;

export const h5 = styled.h5`
  ${h5Css}
`;

export const h6Css = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  margin: 0;
`;

export const h6 = styled.h6`
  ${h6Css}
`;

export const paragraphCss = css`
  font-family: "Avenir Next", Helvetica, sans-serif;
  font-style: normal;
  font-size: 18px;
  line-height: 140%;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 16px;
  }
`;

export const paragraph = styled.p`
  ${paragraphCss}
`;

export const paragraphBigCss = css`
  font-family: "Avenir Next", Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 150%;
  text-transform: uppercase;
  @media ${({ theme }) => theme.breakpoints.xs} {
    font-size: 18px;
  }
`;

export const paragraphBig = styled.p`
  ${paragraphBigCss}
`;

export const paragraphSmallCss = css`
  font-family: "Avenir Next", Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;

export const paragraphSmall = styled.p`
  ${paragraphSmallCss}
`;

export const detailsSmallCss = css`
  font-family: "Avenir Next", Helvetica, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
`;

export const detailsSmall = styled.p`
  ${detailsSmallCss}
`;

export const detailsBigCss = css`
  font-family: "Avenir Next Bold", Helvetica, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  @media ${({ theme }) => theme.breakpoints.md} {
    font-size: 18px;
  }
`;

export const detailsBig = styled.p`
  ${detailsBigCss}
`;

export const Wysiwyg = styled.div<{ color?: string }>`
  color: ${({ color }) => (color ? color : "black")};
  margin-bottom: 30px;

  h1 {
    ${h1Css}
  }

  h2 {
    ${h2Css}
  }

  h3 {
    ${h3Css}
  }

  h4 {
    ${h4Css}
  }

  h5 {
    ${h5Css}
  }

  h6 {
    ${h6Css}
  }

  a {
    ${paragraphCss}
    color: ${({ color }) => color};
  }

  p {
    ${paragraphCss}
    margin-bottom: 2rem;
  }
  span {
    ${paragraphCss}
  }

  img {
    width: 100%;
    height: auto;
    &.size-medium {
      max-width: 400px;
    }
    &.size-thumbnail {
      max-width: 200px;
    }
    &.alignleft {
      float: left;
      margin-right: 20px;
      max-width: 40%;
    }
    &.alignright {
      float: right;
      margin-left: 20px;
      max-width: 40%;
    }
    &.aligncenter {
      margin: 20px auto;
      display: block;
    }
  }

  li {
    ${paragraphCss}
    margin-left: 40px;
    width: calc(100% - 40px);
  }
  ul {
    ${paragraphCss}
  }
  ol {
    ${paragraphCss}
  }
  tr {
    ${paragraphCss}
  }
  td {
    ${paragraphCss}
    vertical-align: top;
    border: 1px solid #ffffff;
    border-collapse: collapse;
    padding: 10px;
  }
  #agenda tr:nth-child(even){background-color: #f2f2f2;}
  #agenda tr:hover {background-color: #ddd;}

  body {
    ${paragraphCss}
  }

  strong {
    font-weight: 700;
    font-family: "Avenir Next Bold", Helvetica, sans-serif;
    em,
    p,
    span,
    li {
      font-weight: 700;
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-top: 20px;
    img {
      margin-bottom: 2rem;
    }
  }
`;

export const a = styled.a``;
